/*
 * @Author: guojia 66291979@qq.com
 * @Date: 2024-05-08 19:10:31
 * @LastEditors: pluto.guo 66291979@qq.com
 * @LastEditTime: 2025-03-10 15:11:45
 * @FilePath: /lobby/src/event/EventCenter.js
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */
export const BUS = {
  SHOW_MENU: 'SHOW_MENU',
  SHOW_POPUP: 'SHOW_POPUP',
  FULL_SCREEN: 'FULL_SCREEN',
  SCROLL_TO_TOP: 'SCROLL_TO_TOP',
  UPDATE_GAME: 'UPDATE_GAME',
  SHOW_DEPOSIT_IN_GAME: 'SHOW_DEPOSIT_IN_GAME',
  REFRESH_PAGE: 'REFRESH_PAGE',
  CHECK_INPUT_VALUE: 'CHECK_INPUT_VALUE',
  PAY_SUCCESS: 'PAY_SUCCESS',
  PAY_INVALID: 'PAY_INVALID',
  UPDATE_GAME_LIST: 'UPDATE_GAME_LIST',
  PUSH_NOTIFICATION: 'PUSH_NOTIFICATION',
  CLOSE_DEPOSIT_IN_GAME: 'CLOSE_DEPOSIT_IN_GAME',
  SHOW_CHAT: 'SHOW_CHAT',
  SHOW_GAME_FOOTER: 'SHOW_GAME_FOOTER',
  HIDE_DEPOSIT_IN_GAME: 'HIDE_DEPOSIT_IN_GAME',
  CHECK_DEPOSIT_STATUS: 'CHECK_DEPOSIT_STATUS',
  SHOW_TOP_BUTTON: 'SHOW_TOP_BUTTON',
  CHANGE_IPUTfIELD_ERROR_TIPS: 'CHANGE_IPUTfIELD_ERROR_TIPS',
  SHOW_SYSTEM_LOADING: 'SHOW_SYSTEM_LOADING',
  UPDATE_BALANCE: 'UPDATE_BALANCE',
  SHOW_SHARE_POPUP: 'SHOW_SHARE_POPUP',
  SHOW_REWARD_POPUP: 'SHOW_REWARD_POPUP',
  BACK_IN_GAME: 'BACK_IN_GAME',
  SHOW_ACTIVE_BOX: 'SHOW_ACTIVE_BOX',
  SHOW_ENVELOPE_NOTIFY: 'SHOW_ENVELOPE_NOTIFY',
  UPDATE_DEEPLINK: 'UPDATE_DEEPLINK',
  CHANGE_SPROT_NAV_TAB: 'CHANGE_SPROT_NAV_TAB',
}

export const POPUP = {
  MENU: 'MENU',
  LOGIN: 'LOGIN',
  REGISTER: 'REGISTER',
  BINDING_PHONE: 'BINDING_PHONE',
  SELECT_COUNTRY: 'SELECT_COUNTRY',
  RESET_PASSWORD: 'RESET_PASSWORD',
  CHANGE_PASSWORD: 'CHANGE_PASSWORD',
  FIRST_DEPOSIT_POPUP: 'FIRST_DEPOSIT_POPUP',
  PERKS_PLAY_POPUP: 'PERKS_PLAY_POPUP'
}
